// idLikeQuery.ts — small standalone helper, split out of CommandPalette.tsx
// so that file keeps a component-only export surface (react-refresh lint).

/**
 * Heuristic for "this query looks like it's targeting a specific ID" — used
 * to offer the palette's "Search all history" escalation even when the
 * backend hasn't (yet, or can't) flagged the execution group as truncated.
 * A single space-free token that's either UUID/hex-ish, or a longish opaque
 * identifier that contains at least one digit, qualifies; anything with
 * whitespace is treated as a normal free-text query. The digit requirement
 * on the second branch matters: without it, a plain long word like
 * "documentation" (12+ alnum chars, no digit) would false-positive and pop
 * the escalation row for an ordinary search term.
 */
export function looksIdLike(q: string): boolean {
  const trimmed = q.trim()
  if (!trimmed || /\s/.test(trimmed)) return false
  if (/^[0-9a-fA-F-]{8,}$/.test(trimmed)) return true
  return /^(?=[a-zA-Z0-9_-]{12,}$)(?=.*[0-9])/.test(trimmed)
}
